module.exports = __webpack_public_path__ + "static/img/drip-switch-document-background.9f69b984.svg";